const loginCodeRetryCount = 3;
const hotline = '1300 249 649';
const loginCodeLength = 6;
const transactionPinLength = 4;

const documentTypes = [
  { id: 'License', text: 'Driver Licence' },
  { id: 'Passport', text: 'Australian Passport' },
];

const genders = [
  { id: 'Male', text: 'Male' },
  { id: 'Female', text: 'Female' },
];

const isDocumentTypeDriversLicence = (documentType) => documentType === documentTypes[0].id;

const isDocumentTypePassport = (documentType) => documentType === documentTypes[1].id;

export const staticDataHelper = {
  loginCodeRetryCount,
  hotline,
  documentTypes,
  genders,
  isDocumentTypeDriversLicence,
  isDocumentTypePassport,
  loginCodeLength,
  transactionPinLength,
};

export const SUPPORTED_FORMATS = ['image/jpg', 'image/jpeg', 'image/png', 'application/pdf'];

export const ATTACHMENT_MAX_FILE_NAME_LENGTH = 80;

export const portalTypes = {
  ShiftPayments: 'SP',
  ClientPortal: 'CP',
  GetCapital: 'GC',
};
